import React from 'react';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { ApGroup } from '@ragu-components/ord-types';

const ApGroupsList = React.lazy(async () => import('./ApGroupsList'));

export const apGroupsResource: OrdResourceProps = {
  key: 'ap_groups',
  name: 'ap_groups',
  list: <ApGroupsList />,
  options: {},
  recordRepresentation: (record: ApGroup) => record.name,
};
